/* eslint-disable camelcase */

import { PlanDetailsMap } from '../../plan-details-map';

export const PlanEditMap = () => {
  return (
    <div style={{ backgroundColor: `white`, width: `100%`, height: `calc(100vh - 64px)` }}>
      <PlanDetailsMap />
    </div>
  );
};
